import { BasicAlert } from "@pharaday/lighthouse";

export const TOP_BANNER_HEIGHT = 46;

export type TopBannerProps = {
  content: string;
};

const TopBanner = ({ content }: TopBannerProps) => {
  return content ? (
    <BasicAlert
      // DO NOT REMOVE `top-banner` class
      className="top-banner flex h-[46px] justify-center overflow-hidden rounded-none bg-primary-50 px-6 py-3 text-white **:truncate"
      title={content}
      type="primary"
    />
  ) : undefined;
};

export default TopBanner;
